import type { CurrentUser } from '@capsio/contracts';
import { useState, type ReactNode } from 'react';
import { api, messageOf } from '../api-client.js';
import { AtmospherePanel } from '../components/AtmospherePanel.js';
import { BusyButton, Field } from '../components/Field.js';

/**
 * 登录。
 *
 * 目前只有密码这一条路。验证码登录和「忘记密码」都要先有一条能发消息的通道，
 * 而通道用什么（客户自己的 SMTP / IM 机器人 / 别的）还没定——定了再把入口接回来。
 * 相关实现都还在：`/api/auth/code/*`、`/api/auth/password-reset/*`、`/forgot-password` 那一页。
 */
export function LoginPage({
  organizationName,
  onSignedIn,
}: {
  organizationName: string;
  onSignedIn: (user: CurrentUser) => void;
}): ReactNode {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function signIn(event: React.FormEvent): Promise<void> {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      onSignedIn(await api.login(email.trim(), password));
    } catch (cause) {
      setError(messageOf(cause));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="split">
      <AtmospherePanel depth={4} statement={organizationName} />

      <main className="form-side">
        <div className="col">
          <div className="head">
            <h1>登录</h1>
          </div>

          <form onSubmit={(event) => void signIn(event)}>
            <Field id="login-email" label="邮箱">
              <input
                id="login-email"
                type="email"
                autoComplete="username"
                placeholder="you@example.com"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </Field>
            <Field id="login-pw" label="密码" error={error}>
              <input
                id="login-pw"
                type="password"
                autoComplete="current-password"
                placeholder="••••••••••••"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            </Field>
            <BusyButton busy={busy} busyLabel="登录中" type="submit">
              登录
            </BusyButton>
          </form>

          <p className="fineprint">没有注册入口。账号由管理员添加。</p>
        </div>
      </main>
    </div>
  );
}
